// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3004G","text":"SelectPayment_text__3r1nq","title":"SelectPayment_title__2_WK0","btn":"SelectPayment_btn__35Szn"};